module.exports = __webpack_public_path__ + "img/logo-david-sr.7ed167c1.png";